import React from 'react';
import { useGame } from '../context/GameContext';
import { ArrowLeft, Zap, Shield, Sparkles } from 'lucide-react';

export default function HowToPlay() {
  const { goToMenu } = useGame();
  return (
    <div className="min-h-screen w-full px-6 py-8 max-w-3xl mx-auto">
      <button className="brutal-btn text-sm" onClick={goToMenu} data-testid="howto-back-button">
        <ArrowLeft size={16} /> BACK
      </button>
      <h1 className="mt-6 font-display text-5xl font-black uppercase text-[color:var(--neon)]">HOW TO SLOP</h1>
      <div className="mt-8 space-y-6 text-sm leading-relaxed">
        <Section icon={Zap} title="TURNS">
          Each turn you get 3 ENERGY and 5 cards. Play cards to attack, block, buff. Then end turn — the enemy plays its telegraphed intent.
        </Section>
        <Section icon={Shield} title="BLOCK">
          BLOCK absorbs damage this turn only. It vanishes at start of your next turn. Time it with the enemy intent.
        </Section>
        <Section icon={Sparkles} title="RUN">
          Climb the map: fights, elites, shops, ??? events, and a boss at F12. Deck grows fatter (or leaner). RIP if HP hits 0.
        </Section>
        <div className="brutal-border-pink p-4">
          <div className="text-xs uppercase tracking-widest text-[color:var(--pink)] mb-2">FRIEND MODE</div>
          Every run has a SEED. Submit your score to get a run code — friends who enter it play the exact same map + enemies + rewards. Highest score wins bragging rights.
        </div>
      </div>
    </div>
  );
}

function Section({ icon: Icon, title, children }) {
  return (
    <div className="flex gap-4">
      <div className="w-12 h-12 brutal-border grid place-items-center shrink-0"><Icon /></div>
      <div>
        <div className="font-display text-xl font-black uppercase text-[color:var(--pink)]">{title}</div>
        <div className="mt-1 text-[color:var(--text)]">{children}</div>
      </div>
    </div>
  );
}
